import axios from "axios";

axios.defaults.withCredentials = true;

export const makeRequest = axios.create({
  baseURL: "https://api.kisssfitness.com",
  //baseURL: "http://localhost:8000",
  withCredentials: true, // If you're handling cookies or sessions
});
